import React from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useForm ,Controller} from "react-hook-form";
import Axios from "axios";
import { useState,useEffect } from 'react';
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import { AddBenchCandidatesProfile,GetCourseInfo,GetJobRoles } from "../apiconstants/constants";
import Swal from 'sweetalert2';
import LoadingSpinner from "../helpers/loadingspinner";
import "../consultant/addeditcandidate/cadidatestyles.css"
import { Link,useLocation} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import mammoth from "mammoth";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const HomeAddCandidate = ()=>{

    const { register, handleSubmit,formState,reset,setValue} = useForm();
    const { errors } = formState
    const { isSubmitting } = formState;
      let query = useQuery();
  const uGuid = query.get("uGuid");
    const CountryID = query.get("CountryID");
    const [isDisabled, setIsDisabled] = useState(false);
    const [Courses,SetCourses]=useState([{}]);
    const [jobRoles,SetJobRoles]=useState([{}]);

    const [isLoading, setIsLoading] = useState(false);
    const [photoURL, setPhotoURL] = useState(null);
    const [maskedResumeCopy, setMaskedResumeCopy] = useState();
    const [imgfile, setimgFile] = useState();
    const [workmode,setWorkMode] = useState([
      {statusID:"1",statusName:"Work from Home"},
      {statusID:"2",statusName:"Work from Office"},
      {statusID:"3",statusName:"Hybrid"}]);
      const [candidateType,setCandidateType] = useState([
      {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
      {candidateTypeID:"C2C",typeName:"C2C"},
      {candidateTypeID:"W2",typeName:"W2"},
    {candidateTypeID:"1099",typeName:"1099"}]);
      const billRatePlaceholder = CountryID == 1 ? 'Expected CTC' : 'Bill Rate';
      const payRatePlaceholder = CountryID == 1 ? ' Current CTC' : 'Pay Rate';
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);
  const [jobPosts, setJobPosts] = useState([]);

const documentLabels = {
  FileUrl: "Resume"
};
const [showModal1, setShowModal1] = useState(false);
const [modalContent, setModalContent] = useState({
  title: '',
  url: '',
});

const [showPreviewModal, setShowPreviewModal] = useState(false);
const [previewFile, setPreviewFile] = useState(null);
const handleShowModal = (docType) => {
  setSelectedDocType(docType);
  setShowModal(true);
};
const handleCloseModal = () => {
  setShowModal(false);
  setSelectedDocType(null);
};
const handleShowModal1 = async (docTypeKey, file) => {
  if (!file) return;

  const fileName = file.name.toLowerCase();

  if (fileName.endsWith(".docx")) {
    // convert DOCX to HTML
    try {
      const arrayBuffer = await file.arrayBuffer();
      const { value } = await mammoth.convertToHtml({ arrayBuffer });
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: value,
        url: null,
        file: file,
      });
    } catch (error) {
      console.error("DOCX preview error", error);
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: "<p>Failed to render DOCX preview.</p>",
        url: null,
        file: file,
      });
    }
  } else {
    const blobUrl = URL.createObjectURL(file);
    setModalContent({
      title: documentLabels[docTypeKey] || docTypeKey,
      url: blobUrl,
      html: null,
      file: file,
    });
  }

  setShowModal1(true);
};
const handleCloseModal1 = () => {
  setShowModal1(false);
};
const renderAttachment = (url, file, html) => {
  if (html) {
    // DOCX preview via mammoth
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  if (!file) {
    return <div>File not found.</div>;
  }

  const name = file.name?.toLowerCase() || "";

  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={url}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  } else  if (name.match(/\.(jpg|jpeg|png)$/)) {
    return (
      <div style={{ textAlign: "center" }}>
        <img
          src={url}
          alt="Image Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "500px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        />
        <div style={{ marginTop: "10px" }}>
          <a
            href={url}
            download={name.replace(/^[0-9a-fA-F-]+_/, "")} // clean name
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#007bff",
              fontWeight: "500",
            }}
          >
            ⬇️ Download Image
          </a>
        </div>
      </div>
    );
  }  else if (name.endsWith(".html") ||
    name.endsWith(".htm")) {
            return (
                <iframe
                    src={url}
                    title="HTML Attachment"
                    style={{ width: '100%', height: '500px', border: 'none' }}
                />
            );
        } else {
    return (
      <div>
        <p style={{ fontSize: 14 }}>
          Preview is not supported for this file type. Please
          <a href={url} download={file.name} style={{ marginLeft: 5 }}>
            download
          </a>
          .
        </p>
      </div>
    );
  }
};
const handleRemoveFile = (docTypeKey) => {
  const updatedFiles = { ...uploadedFiles };
  delete updatedFiles[docTypeKey];
  setUploadedFiles(updatedFiles);
};


const fetchcoursesdata=()=>
    {
      const GetapiUrl=GetCourseInfo.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl);
        let json = await response.json();
        SetCourses(json);
       setValue("QualificationID",3)
       setValue("workMode","Hybrid")
       setValue("clientStatus","New")
      setValue("CandidateType","C2C")
      }
      fetchJSON();
}
const FetchJobroles=()=>
  {
    const GetapiUrl= `${GetJobRoles.APIURL}?UserGuid=${uGuid}&CountryID=${CountryID}`; 
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      SetJobRoles(json);
    }
    fetchJSON();
}


const handleImageUpload = async (event) => {
  const file = event.target.files[0];
  setPhotoURL(file)
  setimgFile(URL.createObjectURL(file));
  var fileInput =document.getElementById('photo');
var filePath = fileInput.value;
       
// Allowing file type
var allowedExtensions =
      /(\.jpg|\.jpeg|\.png)$/i;

if (!allowedExtensions.exec(filePath)) {
Swal.fire({
  text: 'Invalid File Type!',
    })
 // toast.error('Issue with data format', {autoClose:500})
 
  fileInput.value = '';
  setimgFile("");
  
  return false;
}
else
{ 
setimgFile(URL.createObjectURL(event.target.files[0]));
return true;
} 

}

const onSubmit = (data,e) => {
        e.preventDefault();
       if (!uploadedFiles.FileUrl) {
    Swal.fire({
      icon: "error",
      title: "Resume is required",
      text: "Please upload a Resume before submitting",
    });
          return;
        }
        setIsLoading(true);
      
       AddData(data)
    
    }
         const AddData= async(data)=>{
      const formData = new FormData();
      const response = await fetch(defaultimg);
      const imageBlob = await  response.blob();
       formData.append('UserGuid', uGuid);
      formData.append('ProfileSummery', data.ProfileSummery);
      formData.append('Gender', data.gender);
      formData.append('MaritalStatus', data.maritalStatus);
    //  formData.append('ConsultantID',consultantDet[0].consultantID);
      formData.append('QualificationID', data.QualificationID);
      formData.append('Experience', data.experience);
      formData.append('MobileNumber', data.mobileNumber);
      formData.append('CurrentRole', "string");
      formData.append('CandidateType', 'C2C');
      formData.append('JobTitleID', data.jobPost ? data.jobPost?.value : "");
  // Resume string + file
formData.append(
  "Resume",
  uploadedFiles.FileUrl ? uploadedFiles.FileUrl.name : null
);
formData.append("FileUrl", uploadedFiles.FileUrl || null);

// VisaCopy string + file
formData.append(
  "VisaCopy",
  uploadedFiles.VisaCopyUrl ? uploadedFiles.VisaCopyUrl.name : null
);
formData.append("VisaCopyUrl", uploadedFiles.VisaCopyUrl || null);

// DrivingLicence string + file
formData.append(
  "DrivingLicence",
  uploadedFiles.DrivingLicenceUrl ? uploadedFiles.DrivingLicenceUrl.name : null
);
formData.append("DrivingLicenceUrl", uploadedFiles.DrivingLicenceUrl || null);

// Passport string + file
formData.append(
  "Passport",
  uploadedFiles.PassportURL ? uploadedFiles.PassportURL.name : null
);
formData.append("PassportURL", uploadedFiles.PassportURL || null);

// I94 string + file
formData.append(
  "I94",
  uploadedFiles.I94File ? uploadedFiles.I94File.name : null
);
formData.append("I94File", uploadedFiles.I94File || null);
// RTR PDF + file
formData.append(
  "RTR_PDF",
  uploadedFiles.RTR_PDFDoc ? uploadedFiles.RTR_PDFDoc.name : null
);
formData.append("RTR_PDFDoc", uploadedFiles.RTR_PDFDoc || null);
formData.append(
  "Resume_Insights_Pdf",
  uploadedFiles.Resume_Insights_Pdf ? uploadedFiles.Resume_Insights_Pdfdoc.name : null
);
formData.append("OthersDoc", uploadedFiles.OthersDoc || null);
formData.append(
  "Others",
  uploadedFiles.Others ? uploadedFiles.OthersDoc.name : null
);
formData.append("Resume_Insights_Pdfdoc", uploadedFiles.Resume_Insights_Pdfdoc || null);
      formData.append ('Photo', data.photo);
      formData.append('PhotoURL', photoURL?photoURL:defaultimg);
      formData.append('WorkMode', data.workMode);
      formData.append('TechnicalSkill', data.technicalSkill);
      formData.append('Address', data.address);
      formData.append('DOB', data.dob);
      formData.append('FullName', data.fullName);
      formData.append('Email', data.email);
      formData.append('BillRate', data.BillRate);
      formData.append('PayRate', data.PayRate);
      formData.append('WorkAuthorizationandValidity',  CountryID == 2 ? data.WorkAuthorizationandValidity : null);
      formData.append('EmployerName', data.EmployerName);
      formData.append('SSN', CountryID == 2 ? data.SSN : null );
      formData.append('PassportNo', CountryID == 2 ? data.PassportNo : null);
      formData.append('Tworefrencesfromrecentproject', data.Tworefrencesfromrecentproject);
      formData.append('Certifications', data.Certifications);
      formData.append('Comments', data.Comments);
      formData.append('Priority', data.Priority);
      formData.append('JobRole', data.JobRole);
      // formData.append('VisaCopy',data.VisaCopy  );
      // formData.append('VisaCopyUrl', visaCopy );
      formData.append('MaskedResume', data.MaskedResume);
      formData.append('MaskedFileUrl', maskedResumeCopy);
      // formData.append('DrivingLicence',data.DrivingLicence );
      // formData.append('DrivingLicenceUrl',drivingLicence   );
      formData.append('LinkedInUrl', data.LinkedInUrl);
      formData.append('VendorGuid', '');
      formData.append('clientStatus', data.clientStatus);
      formData.append('CreatedBy', 'info@knackhook.com');    
      // const selectedCountry = parseInt(data.CountryMappings);
      formData.append("CountryID", CountryID);
      formData.append('PreferLocation', CountryID);

      const apiAddUrl = AddBenchCandidatesProfile.APIURL;

       Axios.post(apiAddUrl,formData)
       .then((result)=>{
         setIsLoading(false)
          if (result.data.message === "Record created successfully") 
               { 
                 //alert("created");
                 Swal.fire({
                   position: 'center',
                   icon: 'success',
                   title: 'Submitted Successfully ',
                   showConfirmButton: false,
                   timer: 5000
                 })

                    reset();         
               }
               else if (result.data.message===`This Candidate already registered with the ${data.email}`){
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: `This Candidate already registered with the ${data.email}`,
                  showConfirmButton: false,
                  timer: 7000
                })
               }
               else if(result.data.message === " Input data having some issues")
               { 
                 Swal.fire({
                   position: 'center',
                   icon: 'error',
                   title: 'Not Submitted',
                   showConfirmButton: false,
                   timer: 7000
                 })
                 
              // toast.error('Issue with data format', {autoClose:5000})
               }
               
       })
         .catch(()=>{
           setIsLoading(false)
           Swal.fire({
             position: 'center',
             icon: 'error',
             title: 'Something went wrong try again',
             showConfirmButton: false,
             timer: 7000
           })
         })
         }   
       
        
    useEffect(()=>{
      fetchcoursesdata();
      FetchJobroles();
  },[CountryID])
 return(
  <section>
  {
  isLoading ? <center> <LoadingSpinner /> </center> : 
  <div className="container-fluid mt-4 pb-5">
         <div style={{ display: 'flex', alignItems: 'center' }}>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Add Candidate</h2>
</div>

<hr/>
     <div className="bg-gray mt-4">
      
        <form onSubmit={handleSubmit(onSubmit)} id="loginform">
       
       <div class="row p-3">
<div className="col-sm-12 col-lg-2 col-xl-2 col-md-2">
<div className="upload-btn-wrapper text-center"> 
         
<label htmlFor="photo" style={{ cursor: 'pointer' }}>
        <img src={imgfile?imgfile: defaultimg} alt="Upload Image" style={{cursor:"pointer",  borderRadius: '50%',
            width: '100px',
            height: '100px',}} />
        <input
          type="file"
          id="photo"
          style={{ display: 'none' }}
          {...register('photo', { onChange: handleImageUpload })}
        />
       
      </label>
            

          </div>

</div>
<div className="col-sm-12 col-xl-5 col-lg-5 col-md-5">
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>  
          <input type="text" title='' placeholder='Full Name' {...register("fullName", { required: "Fullname Required" })} id="fullName" name="fullName" 
           disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.fullName ? 'is-invalid' : ''}`}
                      />
        </OverlayTrigger>
        <div className="invalid-feedback"> {errors.fullName?.message}</div>

        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>    
   
   <input 
                placeholder='Mobile Number'
                type="Number"
                min="0"
                title=''
                name="mobileNumber"
                disabled={isDisabled}
                {...register("mobileNumber", { required: "Mobile Number Required" })}
                className={`form-control basic-form mt-3 ${errors.mobileNumber ? 'is-invalid' : ''}`}
            />
      </OverlayTrigger>
      <div className="invalid-feedback"> {errors.mobileNumber?.message}</div>

      <div class="mb-2 mt-4" style={{fontSize:12, color:"#495057" }}>
          <label >Gender</label>

          </div>
          <input 
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Male"
        id="field-male"
        disabled={isDisabled}
         defaultChecked
      /> 
      <label style={{ fontSize: 13, color: "#495057", marginRight:'30px',marginLeft:'10px' }}>Male</label>
      
      <input  
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Female"
        id="field-female"
        disabled={isDisabled}
      />
      <label style={{ fontSize: 13, color: "#495057", marginLeft: 10 }}>Female</label>
      
      {errors.gender && <div style={{color:"#dc3545",fontSize:"80%"}}>Gender required</div>}
      
    
            

<div class="mb-2 mt-4" style={{fontSize:12, color:"#495057"}}>
          <lable >Marital Status</lable>
          </div>
        <input
                     {...register("maritalStatus")}
                     type="radio"
                     name="optionalField"
                     title='maritalStatus'
                     value="married"
                     id="maritalStatus"
                     disabled={isDisabled}
                     className="mr-2"
                     defaultChecked
                 /><label style={{fontSize : 13,color:"#495057"}}>Married</label>
                  &nbsp;&nbsp;
                  <input 
                     {...register("maritalStatus")}
                     type="radio"
                     name="optionalField"
                     title='maritalStatus'
                     value="unmarried"
                     id="field-female"
                     
                     disabled={isDisabled}
                 /><label style={{fontSize : 13, color:"#495057", marginLeft : 10}}>Unmarried</label>

             
                     <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Education</Tooltip>)}>    

<select  {...register("QualificationID", { required: "Education Required" })} className={`form-control mt-3 ${errors.QualificationID ? 'is-invalid' : ''}`}style={{height:50 ,borderRadius:15,fontSize:12}}  >
<option value="">Select Education</option>
{
  Courses.map((item,index)=>
  {
    return(

   <option key={index}  value={item.qualificationID}>{item.courseName}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.QualificationID?.message}</div>

                
                  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>{payRatePlaceholder}</Tooltip>)}> 
      <input type="text" name="PayRate" {...register("PayRate")} placeholder={payRatePlaceholder}className={`form-control basic-form mt-3`} />
      </OverlayTrigger>
        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> {billRatePlaceholder} </Tooltip>)}>  
                    <input type="text" placeholder={billRatePlaceholder}{...register("BillRate")} id="BillRate" name="BillRate" 
                    disabled={isDisabled} className={`form-control basic-form mt-3 `}
                                />
                  </OverlayTrigger>
                  {CountryID == 2 &&( <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Current Visa & First US Entry (Visa Type/Year) - Ex H1B & H1B-2019</Tooltip>)}>  

                  <input type="text"  name="dob"
                  {...register("WorkAuthorizationandValidity")}
                  className={`form-control basic-form mt-3`} placeholder="Current Visa & First US Entry (Visa Type/Year) - Ex H1B & H1B-2019" aria-label="WorkAuthorizationandValidity"/>
                  </OverlayTrigger>)}

                  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> EmployerName</Tooltip>)}>  
                    <input type="text" title='' placeholder='Employer Name' {...register("EmployerName")} id="EmployerName" name="EmployerName" 
                    disabled={isDisabled} className={`form-control basic-form mt-3`}
                                />
                  </OverlayTrigger>
               {CountryID == 2 &&  ( <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> SSN</Tooltip>)}>    
            
                  <input 
                  placeholder='Enter last 4 digits of SSN'
                  type="number"
                  name="SSN"
                  {...register("SSN", { 
                    validate: value => {
                      // Check if value is empty
                      if (!value) return true;
                      // Check if value is exactly 4 digits
                      const valueStr = value.toString();
                      if (valueStr.length !== 4) {
                        return "SSN must be exactly 4 digits";
                      }
                      return true;
                    }
                  })}
                  className={`form-control basic-form mt-3`}
                  onInput={(e) => {
                    if (e.target.value.length > 4) {
                      e.target.value = e.target.value.slice(0, 4);
                    }
                  }}
                />
                  </OverlayTrigger>)}
      
                  {CountryID == 2 &&  (    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Passport Number</Tooltip>)}>  
                      <input type="text" title=''  name="optionalField" placeholder='Passport Number' {...register("PassportNo")} id="PassportNo"  
                      className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>)}
      
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Certifications</Tooltip>)}>  
                      <input type="text" title='' placeholder='Certifications' {...register("Certifications")} id="Certifications" name="Certifications" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>
        
                      <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>)}>    

<select  {...register("JobRole", { required: "Job Role Required" })} className={`form-control mt-3 ${errors.JobRole ? 'is-invalid' : ''}`} style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Job Role</option>
{
  jobRoles.map((item,index)=>
  {
    return(

   <option key={index}  value={item.jobRoleId}>{item.jobRole}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.JobRole?.message}</div>

                                
    
                   
       
</div>


  



<div  className="col-sm-12 col-xl-5 col-lg-5 col-md-5">




<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}> 
          <input type="text"  placeholder='Email' id="email" name="email" {...register("email" , { required: "Email Required" })} 
           disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.email ? 'is-invalid' : ''}`}

          />
          </OverlayTrigger>
          <div className="invalid-feedback"> {errors.email?.message}</div>

          <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Date of Birth</Tooltip>)}>
        <input type="date" pattern="/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/"   name="dob"
         {...register("dob")}
         className={`form-control basic-form mt-3 `} placeholder="Date of birth" aria-label="Username"/>
        </OverlayTrigger>
 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Summary</Tooltip>)}>  
          <textarea type="text" style={{height:100}} title='' placeholder='Profile Summary' {...register("ProfileSummery")} id="ProfileSummery" name="ProfileSummery" 
           disabled={isDisabled} className={`form-control basic-form mt-3 `}
                      />
        </OverlayTrigger>
        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Address</Tooltip>)}>     
    <textarea 
                     placeholder='Address'
                     rows="4"
                     title=''
                     name="address"
                     disabled={isDisabled}
                     {...register("address")}
                     className={`form-control basic-form mt-3 `}

                 />
                 </OverlayTrigger>

                 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Experience
</Tooltip>)}>
                      <input type="number" min="0.00" step="0.01"   id="experience"  name="experience" {...register("experience", { required: "Experience Required" })} placeholder="Experience " className={`form-control basic-form mt-3 ${errors.experience ? 'is-invalid' : ''}`}/>
                     </OverlayTrigger>
                     <div className="invalid-feedback"> {errors.experience?.message}</div>
  
                     
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Key Skills</Tooltip>)}> 
<div>
<textarea type="text" style={{height:100}} id="technicalSkill" name="technicalSkill" {...register("technicalSkill", { required: "KeySkills Required" })} placeholder="Enter Key Skills " className={`form-control basic-form mt-3 ${errors.technicalSkill ? 'is-invalid' : ''}`} />

</div>
</OverlayTrigger> 

<div className="invalid-feedback"> {errors.technicalSkill?.message}</div>

<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Work Mode</Tooltip>)}>    

<select  {...register("workMode", { required: "Work Mode Required" })} className={`form-control mt-3 ${errors.workMode ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15,fontSize:12}}  >
<option value="">Select Work Mode </option>
{
workmode.map((item,index)=>
{
return(

<option key={index}  value={item.statusName}>{item.statusName}</option>

);
}

)
}
</select>
</OverlayTrigger>
{ <div className="invalid-feedback">{errors.workMode?.message}</div> }



            <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Priority</Tooltip>)}> 
      <input type="text" name="Priority" {...register("Priority")} value={1} placeholder="Priority " 
      className={`form-control basic-form mt-3 `} />
      </OverlayTrigger>
       <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Two References from Recent Project</Tooltip>)}>  
                      <input type="text" title='' placeholder='Two References from Recent Project' {...register("Tworefrencesfromrecentproject")} id="Tworefrencesfromrecentproject" name="Tworefrencesfromrecentproject" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>
     
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>LinkedIn Url</Tooltip>)}>  
          <input type="text" title='' placeholder='LinkedIn Url' {...register("LinkedInUrl")} id="LinkedInUrl" name="LinkedInUrl" 
           className={`form-control basic-form mt-3 `}/>
        </OverlayTrigger>     
<br/>  
    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Upload Documents
</Tooltip>)}>
<select 
  onChange={(e) => {
    setSelectedDocType(e.target.value);

    handleShowModal(e.target.value);  // open modal
     e.target.value ="";
  }}
className={`form-control `}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Any Document</option>
  <option value="Resume"> Resume </option>
</select>
                     </OverlayTrigger>
                    
                   <div>
 {Object.keys(uploadedFiles).map((docTypeKey) => {
  const file = uploadedFiles[docTypeKey];
  const displayLabel = documentLabels[docTypeKey] || docTypeKey; // fallback
  return (
 <div key={docTypeKey}>
  <strong style={{ fontSize: 12 }}>{displayLabel} :</strong> &nbsp;
  <span style={{ fontSize: 12 }}>{file.name}</span>
  &nbsp; | &nbsp;
  <button
  type="button"
  style={{
    border: "none",
    background: "transparent",
    color: "blue",
    fontSize: 12,
    cursor: "pointer"
  }}
  onClick={() => handleShowModal1(docTypeKey, file)}
>
  View
</button>
  &nbsp; | &nbsp;
  <button
    type="button"
    style={{
      border: "none",
      background: "transparent",
      color: "red",
      fontSize: 12,
      cursor: "pointer"
    }}
    onClick={() => handleRemoveFile(docTypeKey)}
  >
    Remove
  </button>
  
</div>

  );
})}


              </div>

</div>


</div>

 
 <div class="row mb-4 mt-3 ">
    <div class="col-12">  
    
            
               </div>
               </div>
               <Link to="/Employer/GetCandidatesByEmployerUserID"> 
                <button  style={{float:"right"}}  disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                  Cancel
                </button>
                </Link>
       <button id="svbutton" style={{float:"right"}} disabled={isSubmitting || isDisabled } className="btn btn-primary pf-save mb-3 mr-3" >
                     {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                     Save
                 </button> &nbsp;&nbsp;&nbsp;
     
     </form>
    

   </div>

</div>

 }

<Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Header closeButton>
    <Modal.Title style={{color:"#00a7ac"}}>Upload {selectedDocType}</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{height:100}}>
    <input type="file" accept=".pdf,.jpg,.jpeg,.png,.docx" 

      style={{fontSize:18,color:"#00a7ac"}}
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        const originalFileName = file.name;
        // replace special characters
        const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, "_");

        // allow only PDF, DOC, DOCX
        const allowedExtensions = /\.(pdf|doc|docx|jpg|jpeg|png)$/i;
        if (!allowedExtensions.test(sanitizedFileName)) {
          Swal.fire({
            icon: "error",
            text: "Invalid file type. Only PDF, DOC, or DOCX allowed.",
          });
          e.target.value = "";
          return;
        }

        // create new file with sanitized name
        const renamedFile = new File([file], sanitizedFileName, { type: file.type });

        let fileField = "";
        switch (selectedDocType) {
          case "Resume":
            fileField = "FileUrl";
            break;
          default:
            fileField = `${selectedDocType}Url`;
        }

        setUploadedFiles((prev) => ({
          ...prev,
          [fileField]: renamedFile,
        }));

        handleCloseModal();
        setSelectedDocType("");
      }}
    />
  </Modal.Body>
</Modal>
<Modal show={showModal1} onHide={handleCloseModal1} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>{modalContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {renderAttachment(modalContent.url, modalContent.file, modalContent.html)}
  </Modal.Body>
</Modal>





 </section>

    )
}
export default HomeAddCandidate;